import {
  GET_REVIEW_LIST,
  GET_REVIEW_LIST_SUCCESS,
  GET_REVIEW_LIST_FAILURE,
  GET_REVIEW_DATA,
  GET_REVIEW_DATA_SUCCESS,
  GET_REVIEW_DATA_FAILURE,
  CREATE_REVIEW,
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  UPDATE_REVIEW,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_FAILURE,
  DELETE_REVIEW,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAILURE,
  ASSIGN_REVIEW_CUSTOMER,
  ASSIGN_REVIEW_CUSTOMER_SUCCESS,
  ASSIGN_REVIEW_CUSTOMER_FAILURE,
  SET_REVIEW_STATUS,
  SET_REVIEW_STATUS_SUCCESS,
  SET_REVIEW_STATUS_FAILURE,
  REPLY_REVIEW,
  REPLY_REVIEW_SUCCESS,
  REPLY_REVIEW_FAILURE,
  GET_REVIEW_PROVIDERS,
  GET_REVIEW_PROVIDERS_SUCCESS,
  GET_REVIEW_PROVIDERS_FAILURE,
  UPDATE_REVIEW_PROVIDER,
  UPDATE_REVIEW_PROVIDER_SUCCESS,
  UPDATE_REVIEW_PROVIDER_FAILURE,
  SYNC_REVIEW_GOOGLE,
  SYNC_REVIEW_GOOGLE_SUCCESS,
  SYNC_REVIEW_GOOGLE_FAILURE,
  GET_REVIEW_STATUS_LIST,
  GET_REVIEW_STATUS_LIST_SUCCESS,
  GET_REVIEW_STATUS_LIST_FAILURE,
  GET_REVIEW_STATUS_DATA,
  GET_REVIEW_STATUS_DATA_SUCCESS,
  GET_REVIEW_STATUS_DATA_FAILURE,
  CREATE_REVIEW_STATUS,
  CREATE_REVIEW_STATUS_SUCCESS,
  CREATE_REVIEW_STATUS_FAILURE,
  UPDATE_REVIEW_STATUS,
  UPDATE_REVIEW_STATUS_SUCCESS,
  UPDATE_REVIEW_STATUS_FAILURE,
  DELETE_REVIEW_STATUS,
  DELETE_REVIEW_STATUS_SUCCESS,
  DELETE_REVIEW_STATUS_FAILURE,
} from "./actionType";

// ---- Reviews ----
// List
export const getReviewList = () => ({ type: GET_REVIEW_LIST });
export const getReviewListSuccess = (response) => ({
  type: GET_REVIEW_LIST_SUCCESS,
  payload: response,
});
export const getReviewListFailure = (error) => ({
  type: GET_REVIEW_LIST_FAILURE,
  payload: error,
});

// Read one
export const getReviewData = (data) => ({ type: GET_REVIEW_DATA, payload: data });
export const getReviewDataSuccess = (response) => ({
  type: GET_REVIEW_DATA_SUCCESS,
  payload: response,
});
export const getReviewDataFailure = (error) => ({
  type: GET_REVIEW_DATA_FAILURE,
  payload: error,
});

// Create
export const createReview = (data) => ({ type: CREATE_REVIEW, payload: data });
export const createReviewSuccess = (response) => ({
  type: CREATE_REVIEW_SUCCESS,
  payload: response,
});
export const createReviewFailure = (error) => ({
  type: CREATE_REVIEW_FAILURE,
  payload: error,
});

// Update
export const updateReview = (data) => ({ type: UPDATE_REVIEW, payload: data });
export const updateReviewSuccess = (response) => ({
  type: UPDATE_REVIEW_SUCCESS,
  payload: response,
});
export const updateReviewFailure = (error) => ({
  type: UPDATE_REVIEW_FAILURE,
  payload: error,
});

// Delete (array of IDs)
export const deleteReview = (data) => ({ type: DELETE_REVIEW, payload: data });
export const deleteReviewSuccess = (response) => ({
  type: DELETE_REVIEW_SUCCESS,
  payload: response,
});
export const deleteReviewFailure = (error) => ({
  type: DELETE_REVIEW_FAILURE,
  payload: error,
});

// Assign to customer
export const assignReviewCustomer = (data) => ({
  type: ASSIGN_REVIEW_CUSTOMER,
  payload: data,
});
export const assignReviewCustomerSuccess = (response) => ({
  type: ASSIGN_REVIEW_CUSTOMER_SUCCESS,
  payload: response,
});
export const assignReviewCustomerFailure = (error) => ({
  type: ASSIGN_REVIEW_CUSTOMER_FAILURE,
  payload: error,
});

// Set status / assignee
export const setReviewStatus = (data) => ({
  type: SET_REVIEW_STATUS,
  payload: data,
});
export const setReviewStatusSuccess = (response) => ({
  type: SET_REVIEW_STATUS_SUCCESS,
  payload: response,
});
export const setReviewStatusFailure = (error) => ({
  type: SET_REVIEW_STATUS_FAILURE,
  payload: error,
});

// Reply
export const replyReview = (data) => ({ type: REPLY_REVIEW, payload: data });
export const replyReviewSuccess = (response) => ({
  type: REPLY_REVIEW_SUCCESS,
  payload: response,
});
export const replyReviewFailure = (error) => ({
  type: REPLY_REVIEW_FAILURE,
  payload: error,
});

// ---- Review Providers ----
export const getReviewProviders = () => ({ type: GET_REVIEW_PROVIDERS });
export const getReviewProvidersSuccess = (response) => ({
  type: GET_REVIEW_PROVIDERS_SUCCESS,
  payload: response,
});
export const getReviewProvidersFailure = (error) => ({
  type: GET_REVIEW_PROVIDERS_FAILURE,
  payload: error,
});

export const updateReviewProvider = (data) => ({
  type: UPDATE_REVIEW_PROVIDER,
  payload: data,
});
export const updateReviewProviderSuccess = (response) => ({
  type: UPDATE_REVIEW_PROVIDER_SUCCESS,
  payload: response,
});
export const updateReviewProviderFailure = (error) => ({
  type: UPDATE_REVIEW_PROVIDER_FAILURE,
  payload: error,
});

export const syncReviewGoogle = () => ({ type: SYNC_REVIEW_GOOGLE });
export const syncReviewGoogleSuccess = (response) => ({
  type: SYNC_REVIEW_GOOGLE_SUCCESS,
  payload: response,
});
export const syncReviewGoogleFailure = (error) => ({
  type: SYNC_REVIEW_GOOGLE_FAILURE,
  payload: error,
});

// ---- Review Status lanes ----
export const getReviewStatusList = () => ({ type: GET_REVIEW_STATUS_LIST });
export const getReviewStatusListSuccess = (response) => ({
  type: GET_REVIEW_STATUS_LIST_SUCCESS,
  payload: response,
});
export const getReviewStatusListFailure = (error) => ({
  type: GET_REVIEW_STATUS_LIST_FAILURE,
  payload: error,
});

export const getReviewStatusData = (data) => ({
  type: GET_REVIEW_STATUS_DATA,
  payload: data,
});
export const getReviewStatusDataSuccess = (response) => ({
  type: GET_REVIEW_STATUS_DATA_SUCCESS,
  payload: response,
});
export const getReviewStatusDataFailure = (error) => ({
  type: GET_REVIEW_STATUS_DATA_FAILURE,
  payload: error,
});

export const createReviewStatus = (data) => ({
  type: CREATE_REVIEW_STATUS,
  payload: data,
});
export const createReviewStatusSuccess = (response) => ({
  type: CREATE_REVIEW_STATUS_SUCCESS,
  payload: response,
});
export const createReviewStatusFailure = (error) => ({
  type: CREATE_REVIEW_STATUS_FAILURE,
  payload: error,
});

export const updateReviewStatus = (data) => ({
  type: UPDATE_REVIEW_STATUS,
  payload: data,
});
export const updateReviewStatusSuccess = (response) => ({
  type: UPDATE_REVIEW_STATUS_SUCCESS,
  payload: response,
});
export const updateReviewStatusFailure = (error) => ({
  type: UPDATE_REVIEW_STATUS_FAILURE,
  payload: error,
});

export const deleteReviewStatus = (data) => ({
  type: DELETE_REVIEW_STATUS,
  payload: data,
});
export const deleteReviewStatusSuccess = (response) => ({
  type: DELETE_REVIEW_STATUS_SUCCESS,
  payload: response,
});
export const deleteReviewStatusFailure = (error) => ({
  type: DELETE_REVIEW_STATUS_FAILURE,
  payload: error,
});
